<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0 avaliacao-card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 table-responsive">
          <!-- CHART OVERLAY -->
          <div v-if="showChart" class="chart-overlay" @click.self="showChart = false">
              <div class="chart-modal">
                  <div class="chart-modal-header">
                      <span><i class="fas fa-chart-bar me-2"></i>Gráfico de Circunferências</span>
                      <button class="btn-chart-close" @click="showChart = false"><i class="fas fa-times"></i></button>
                  </div>
                  <div class="chart-modal-body">
                      <canvas ref="circChartCanvas"></canvas>
                  </div>
              </div>
          </div>

          <table class="table border table-sm table-striped circ-table">
            <thead>
              <tr class="font-weight-bold text-center">
                <td class="text-start">
                  {{ $t('circumferences') }}
                  <button class="btn-chart-toggle-sm ms-2" @click="showChart = !showChart" :title="showChart ? 'Esconder gráfico' : 'Ver gráfico'">
                    <i class="fas fa-chart-bar"></i>
                  </button>
                </td>
                <td>{{ $t('current') }}</td>
                <td>{{ $t('first') }}</td>
                <td>{{ $t('previous') }}</td>
                <td>{{ $t('currentFirst') }}</td>
                <td>{{ $t('currentPrevious') }}</td>
              </tr>
            </thead>
            <tbody class="text-sm">
              <tr class="text-center">
                <td class="text-start">{{ $t('shoulders') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_shoulders"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_shoulders }}</td>
                <td>{{ state.composicaoAnterior.circ_shoulders }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_shoulders, state.composicaoPrimeira.circ_shoulders))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_shoulders,
                      state.composicaoPrimeira.circ_shoulders,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_shoulders, state.composicaoAnterior.circ_shoulders))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_shoulders,
                      state.composicaoAnterior.circ_shoulders,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('chest') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_chest"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_chest }}</td>
                <td>{{ state.composicaoAnterior.circ_chest }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_chest, state.composicaoPrimeira.circ_chest))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_chest,
                      state.composicaoPrimeira.circ_chest,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_chest, state.composicaoAnterior.circ_chest))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_chest,
                      state.composicaoAnterior.circ_chest,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('rightArm') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_right_arm"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_right_arm }}</td>
                <td>{{ state.composicaoAnterior.circ_right_arm }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_right_arm, state.composicaoPrimeira.circ_right_arm))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_right_arm,
                      state.composicaoPrimeira.circ_right_arm,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_right_arm, state.composicaoAnterior.circ_right_arm))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_right_arm,
                      state.composicaoAnterior.circ_right_arm,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('rightForearm') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_right_forearm"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_right_forearm }}</td>
                <td>{{ state.composicaoAnterior.circ_right_forearm }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_right_forearm, state.composicaoPrimeira.circ_right_forearm))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_right_forearm,
                      state.composicaoPrimeira.circ_right_forearm,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_right_forearm, state.composicaoAnterior.circ_right_forearm))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_right_forearm,
                      state.composicaoAnterior.circ_right_forearm,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('leftArm') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_left_arm"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_left_arm }}</td>
                <td>{{ state.composicaoAnterior.circ_left_arm }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_left_arm, state.composicaoPrimeira.circ_left_arm))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_left_arm,
                      state.composicaoPrimeira.circ_left_arm,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_left_arm, state.composicaoAnterior.circ_left_arm))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_left_arm,
                      state.composicaoAnterior.circ_left_arm,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('leftForearm') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_left_forearm"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_left_forearm }}</td>
                <td>{{ state.composicaoAnterior.circ_left_forearm }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_left_forearm, state.composicaoPrimeira.circ_left_forearm))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_left_forearm,
                      state.composicaoPrimeira.circ_left_forearm,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_left_forearm, state.composicaoAnterior.circ_left_forearm))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_left_forearm,
                      state.composicaoAnterior.circ_left_forearm,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('waist') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_waist"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_waist }}</td>
                <td>{{ state.composicaoAnterior.circ_waist }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_waist, state.composicaoPrimeira.circ_waist))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_waist,
                      state.composicaoPrimeira.circ_waist,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_waist, state.composicaoAnterior.circ_waist))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_waist,
                      state.composicaoAnterior.circ_waist,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('abdomen') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_abdomen"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_abdomen }}</td>
                <td>{{ state.composicaoAnterior.circ_abdomen }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_abdomen, state.composicaoPrimeira.circ_abdomen))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_abdomen,
                      state.composicaoPrimeira.circ_abdomen,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_abdomen, state.composicaoAnterior.circ_abdomen))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_abdomen,
                      state.composicaoAnterior.circ_abdomen,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('hip') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_hip"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_hip }}</td>
                <td>{{ state.composicaoAnterior.circ_hip }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_hip, state.composicaoPrimeira.circ_hip))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_hip,
                      state.composicaoPrimeira.circ_hip,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_hip, state.composicaoAnterior.circ_hip))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_hip,
                      state.composicaoAnterior.circ_hip,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('rightThigh') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_right_thigh"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_right_thigh }}</td>
                <td>{{ state.composicaoAnterior.circ_right_thigh }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_right_thigh, state.composicaoPrimeira.circ_right_thigh))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_right_thigh,
                      state.composicaoPrimeira.circ_right_thigh,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_right_thigh, state.composicaoAnterior.circ_right_thigh))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_right_thigh,
                      state.composicaoAnterior.circ_right_thigh,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('rightCalf') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_right_calf"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_right_calf }}</td>
                <td>{{ state.composicaoAnterior.circ_right_calf }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_right_calf, state.composicaoPrimeira.circ_right_calf))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_right_calf,
                      state.composicaoPrimeira.circ_right_calf,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_right_calf, state.composicaoAnterior.circ_right_calf))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_right_calf,
                      state.composicaoAnterior.circ_right_calf,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('leftThigh') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_left_thigh"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_left_thigh }}</td>
                <td>{{ state.composicaoAnterior.circ_left_thigh }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_left_thigh, state.composicaoPrimeira.circ_left_thigh))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_left_thigh,
                      state.composicaoPrimeira.circ_left_thigh,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_left_thigh, state.composicaoAnterior.circ_left_thigh))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_left_thigh,
                      state.composicaoAnterior.circ_left_thigh,
                    )
                  }}
                  </span>
                </td>
              </tr>
              <tr class="text-center">
                <td class="text-start">{{ $t('leftCalf') }}</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm circ-input"
                    style="width: 55px"
                    v-model="state.composicaoAtual.circ_left_calf"
                  />
                </td>
                <td>{{ state.composicaoPrimeira.circ_left_calf }}</td>
                <td>{{ state.composicaoAnterior.circ_left_calf }}</td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(state.composicaoAtual.circ_left_calf, state.composicaoPrimeira.circ_left_calf))">
                  {{
                    diferencialAtualPrimeiro(
                      state.composicaoAtual.circ_left_calf,
                      state.composicaoPrimeira.circ_left_calf,
                    )
                  }}
                  </span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(state.composicaoAtual.circ_left_calf, state.composicaoAnterior.circ_left_calf))">
                  {{
                    diferencialAtualAnterior(
                      state.composicaoAtual.circ_left_calf,
                      state.composicaoAnterior.circ_left_calf,
                    )
                  }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold text-center">
                <td class="text-start">{{ $t('total') }}</td>
                <td class="text-start">{{ somaAtual }}</td>
                <td>{{ somaPrimeiro }}</td>
                <td>{{ somaAnterior }}</td>
                <td><span :class="diffClass(somaAtual - somaPrimeiro)">{{ somaAtual - somaPrimeiro }}</span></td>
                <td><span :class="diffClass(somaAtual - somaAnterior)">{{ somaAtual - somaAnterior }}</span></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="col-12 text-end">
          <router-link to="/avaliacao-fisica">
            <button type="button" class="btn bg-gradient-secondary">
              {{ $t('back') }}
            </button>
          </router-link>
          <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import circunferenciaRepository from '../../../../../services/api/composicaoCorporalCircunferenciaRepository'
import { useRouter, useRoute } from 'vue-router'
import CircunferenceModel from '@/models/circunferenciaModel'
import { useI18n } from 'vue-i18n'
import Chart from 'chart.js/auto'

export default {
  props: {
    avaliacaoIdProp: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const { t } = useI18n() // Import the translation function
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(() => {
      state.avaliacaoId = props.avaliacaoIdProp
      buscarDadosComposicao()
    })

    const state = reactive({
      displayComponent: false,
      composicaoAtual: new CircunferenceModel(),
      composicaoAnterior: new CircunferenceModel(),
      composicaoPrimeira: new CircunferenceModel(),
      dadosSalvos: false,
      avaliacaoId: 0,
    })

    async function buscarDadosComposicao() {
      store.commit('SET_SPLASH_SCREEN', true)
      try {
        if (state.avaliacaoId == 0) {
          let responseFirst = await circunferenciaRepository.CircunferenciaGetFirst()
          let responseLast = await circunferenciaRepository.CircunferenciaGetLatest()
          store.commit('SET_SPLASH_SCREEN', false)

          if (responseFirst.data.success && responseFirst.data.data != null) {
            state.composicaoPrimeira = responseFirst.data.data
          }
          if (responseLast.data.success && responseLast.data.data != null) {
            state.composicaoAnterior = responseLast.data.data
          }
        } else {
          let response = await circunferenciaRepository.CircunferenciaGetByAssessmentId(
            state.avaliacaoId,
          )
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            if (response.data.data.item != null) {
              state.composicaoAtual = Object.assign(
                new CircunferenceModel(),
                response.data.data.item,
              )
            }
            if (response.data.data.before != null) {
              state.composicaoAnterior = Object.assign(
                new CircunferenceModel(),
                response.data.data.before,
              )
            }
            if (response.data.data.first != null) {
              state.composicaoPrimeira = Object.assign(
                new CircunferenceModel(),
                response.data.data.first,
              )
            }
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      }
    }

    const somaAtual = computed(() => {
      return parseFloat(
        (
          parseFloat(state.composicaoAtual.circ_shoulders || 0) +
          parseFloat(state.composicaoAtual.circ_chest || 0) +
          parseFloat(state.composicaoAtual.circ_right_arm || 0) +
          parseFloat(state.composicaoAtual.circ_right_forearm || 0) +
          parseFloat(state.composicaoAtual.circ_left_arm || 0) +
          parseFloat(state.composicaoAtual.circ_left_forearm || 0) +
          parseFloat(state.composicaoAtual.circ_waist || 0) +
          parseFloat(state.composicaoAtual.circ_abdomen || 0) +
          parseFloat(state.composicaoAtual.circ_hip || 0) +
          parseFloat(state.composicaoAtual.circ_right_thigh || 0) +
          parseFloat(state.composicaoAtual.circ_right_calf || 0) +
          parseFloat(state.composicaoAtual.circ_left_thigh || 0) +
          parseFloat(state.composicaoAtual.circ_left_calf || 0)
        ).toFixed(2),
      )
    })

    const somaAnterior = computed(() => {
      return parseFloat(
        (
          parseFloat(state.composicaoAnterior.circ_shoulders || 0) +
          parseFloat(state.composicaoAnterior.circ_chest || 0) +
          parseFloat(state.composicaoAnterior.circ_right_arm || 0) +
          parseFloat(state.composicaoAnterior.circ_right_forearm || 0) +
          parseFloat(state.composicaoAnterior.circ_left_arm || 0) +
          parseFloat(state.composicaoAnterior.circ_left_forearm || 0) +
          parseFloat(state.composicaoAnterior.circ_waist || 0) +
          parseFloat(state.composicaoAnterior.circ_abdomen || 0) +
          parseFloat(state.composicaoAnterior.circ_hip || 0) +
          parseFloat(state.composicaoAnterior.circ_right_thigh || 0) +
          parseFloat(state.composicaoAnterior.circ_right_calf || 0) +
          parseFloat(state.composicaoAnterior.circ_left_thigh || 0) +
          parseFloat(state.composicaoAnterior.circ_left_calf || 0)
        ).toFixed(2),
      )
    })

    const somaPrimeiro = computed(() => {
      return parseFloat(
        (
          parseFloat(state.composicaoPrimeira.circ_shoulders || 0) +
          parseFloat(state.composicaoPrimeira.circ_chest || 0) +
          parseFloat(state.composicaoPrimeira.circ_right_arm || 0) +
          parseFloat(state.composicaoPrimeira.circ_right_forearm || 0) +
          parseFloat(state.composicaoPrimeira.circ_left_arm || 0) +
          parseFloat(state.composicaoPrimeira.circ_left_forearm || 0) +
          parseFloat(state.composicaoPrimeira.circ_waist || 0) +
          parseFloat(state.composicaoPrimeira.circ_abdomen || 0) +
          parseFloat(state.composicaoPrimeira.circ_hip || 0) +
          parseFloat(state.composicaoPrimeira.circ_right_thigh || 0) +
          parseFloat(state.composicaoPrimeira.circ_right_calf || 0) +
          parseFloat(state.composicaoPrimeira.circ_left_thigh || 0) +
          parseFloat(state.composicaoPrimeira.circ_left_calf || 0)
        ).toFixed(2),
      )
    })

    function salvar() {
      try {
        if (state.avaliacaoId == 0 && route.params.id && parseInt(route.params.id) > 0) {
          state.avaliacaoId = parseInt(route.params.id)
        }
        store.commit('SET_SPLASH_SCREEN', true)
        if (state.avaliacaoId == 0) {
          context.emit('salvar', state.composicaoAtual, 'circunferencia')
        } else {
          state.composicaoAtual.student_physical_assessment_id = state.avaliacaoId
          if (state.composicaoAtual.id == undefined || state.composicaoAtual.id == 0) {
            delete state.composicaoAtual.id
            circunferenciaRepository.CircunferenciaPost(state.composicaoAtual).then((response) => {
              store.commit('SET_SPLASH_SCREEN', false)

              if (response.data.success) {
                context.emit('salvaCircunferencia', response.data.data)
                swal({
                  title: t('measurements'), // Use translation
                  text: t('circumferencesSavedSuccessfully'), // Use translation
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn bg-gradient-success',
                  },
                  buttonsStyling: false,
                })
              }
            })
          } else {
            circunferenciaRepository
              .CircunferenciaPut(state.composicaoAtual.id, state.composicaoAtual)
              .then((response) => {
                store.commit('SET_SPLASH_SCREEN', false)

                if (response.data.success) {
                  context.emit('salvaCircunferencia', response.data.data)
                  swal({
                    title: t('measurements'), // Use translation
                    text: t('circumferencesSavedSuccessfully'), // Use translation
                    icon: 'success',
                    customClass: {
                      confirmButton: 'btn bg-gradient-success',
                    },
                    buttonsStyling: false,
                  })
                }
              })
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
        state.dadosSalvos = true
      }
    }

    function voltar() {
      if (state.dadosSalvos) {
        router.push('/composicao-corporal')
      } else {
        swal({
          title: t('unsavedData'), // Use translation
          text: t('unsavedCircumferenceData'), // Use translation
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: t('exitWithoutSaving'), // Use translation
          cancelButtonText: t('cancel'), // Use translation
        }).then((result) => {
          if (result.isConfirmed) {
            router.push('/composicao-corporal')
          }
        })
      }
    }

    function diffClass(value) {
      const num = parseFloat(value)
      if (isNaN(num) || num === 0) return 'diff-zero'
      return num > 0 ? 'diff-positive' : 'diff-negative'
    }

    function diferencialAtualPrimeiro(atual, anterior) {
      return parseFloat(anterior) > 0 ? (parseFloat(atual) - parseFloat(anterior)).toFixed(2) : 0
    }

    function diferencialAtualAnterior(atual, anterior) {
      return parseFloat(anterior) > 0 ? (parseFloat(atual) - parseFloat(anterior)).toFixed(2) : 0
    }

    const showChart = ref(false)
    const circChartCanvas = ref(null)
    let chartInstance = null

    watch(showChart, async (val) => {
      if (val) {
        await nextTick()
        renderCircChart()
      } else {
        if (chartInstance) {
          chartInstance.destroy()
          chartInstance = null
        }
      }
    })

    function renderCircChart() {
      if (!circChartCanvas.value) return
      if (chartInstance) chartInstance.destroy()
      const ctx = circChartCanvas.value.getContext('2d')
      const fields = [
        { key: 'circ_shoulders', label: t('shoulders') },
        { key: 'circ_chest', label: t('chest') },
        { key: 'circ_right_arm', label: t('rightArm') },
        { key: 'circ_right_forearm', label: t('rightForearm') },
        { key: 'circ_left_arm', label: t('leftArm') },
        { key: 'circ_left_forearm', label: t('leftForearm') },
        { key: 'circ_waist', label: t('waist') },
        { key: 'circ_abdomen', label: t('abdomen') },
        { key: 'circ_hip', label: t('hip') },
        { key: 'circ_right_thigh', label: t('rightThigh') },
        { key: 'circ_right_calf', label: t('rightCalf') },
        { key: 'circ_left_thigh', label: t('leftThigh') },
        { key: 'circ_left_calf', label: t('leftCalf') },
      ]
      const labels = fields.map(f => f.label)
      const dataAtual = fields.map(f => parseFloat(state.composicaoAtual[f.key]) || 0)
      const dataPrimeira = fields.map(f => parseFloat(state.composicaoPrimeira[f.key]) || 0)
      const dataAnterior = fields.map(f => parseFloat(state.composicaoAnterior[f.key]) || 0)

      chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            { label: 'Atual', data: dataAtual, backgroundColor: '#F7941D', borderColor: '#F7941D', borderWidth: 2, borderRadius: 4 },
            { label: 'Primeira', data: dataPrimeira, backgroundColor: '#2D3A7C', borderColor: '#2D3A7C', borderWidth: 2, borderRadius: 4 },
            { label: 'Anterior', data: dataAnterior, backgroundColor: '#7B8ABF', borderColor: '#7B8ABF', borderWidth: 2, borderRadius: 4 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top', labels: { font: { size: 12, weight: 'bold' }, padding: 14, usePointStyle: true, pointStyle: 'circle' } },
            tooltip: { backgroundColor: '#2D3A7C', cornerRadius: 8, padding: 10 }
          },
          scales: {
            y: { beginAtZero: true, grid: { color: 'rgba(45,58,124,0.08)' }, ticks: { font: { size: 10 }, color: '#344767' } },
            x: { grid: { display: false }, ticks: { font: { size: 9, weight: 'bold' }, color: '#2D3A7C', maxRotation: 45, minRotation: 30 } }
          }
        }
      })
    }

    return {
      state,
      somaAtual,
      somaAnterior,
      somaPrimeiro,
      salvar,
      voltar,
      diferencialAtualAnterior,
      diferencialAtualPrimeiro,
      diffClass,
      showChart,
      circChartCanvas,
    }
  },
}
</script>

<style scoped>
.avaliacao-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.circ-table thead td,
.circ-table thead th {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 8px;
  border-color: #354585 !important;
}
.circ-table tbody td {
  padding: 8px 8px;
  vertical-align: middle;
  color: #344767;
  font-size: 0.85rem;
}
.circ-table tbody td.text-start {
  font-weight: 600;
  color: #2D3A7C;
}
.circ-table tbody tr:nth-child(even) {
  background: #f0f2f7;
}
.circ-table tbody tr:nth-child(odd) {
  background: #fff;
}
.circ-table tbody tr:hover {
  background: #ebeff5;
}
.circ-table tfoot td {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.88rem;
  padding: 10px 8px;
  border-color: #354585 !important;
}
.circ-input {
  border: 2px solid #2D3A7C !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
  color: #2D3A7C !important;
  text-align: center;
  width: 60px !important;
  background: #edf0f6 !important;
  transition: all 0.2s;
}
.circ-input:focus {
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.2) !important;
  background: #fff !important;
}
.diff-positive {
  display: inline-block;
  background: rgba(45, 206, 137, 0.12);
  color: #2dce89;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.82rem;
}
.diff-negative {
  display: inline-block;
  background: rgba(245, 54, 92, 0.1);
  color: #f5365c;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.82rem;
}
.diff-zero {
  display: inline-block;
  background: rgba(131, 146, 171, 0.1);
  color: #8392ab;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.82rem;
}
/* Chart button inline */
.btn-chart-toggle-sm {
  background: #F7941D;
  border: none;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  vertical-align: middle;
  box-shadow: 0 2px 6px rgba(247,148,29,0.3);
}
.btn-chart-toggle-sm:hover {
  background: #e5850f;
  transform: scale(1.1);
}
/* Chart overlay/modal */
.chart-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.chart-modal {
  background: #fff;
  border-radius: 16px;
  width: 92%;
  max-width: 900px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  overflow: hidden;
  animation: chartSlideIn 0.3s ease;
}
@keyframes chartSlideIn {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.chart-modal-header {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  color: #fff;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-chart-close {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-chart-close:hover {
  background: #F7941D;
}
.chart-modal-body {
  padding: 24px;
  height: 420px;
}
</style>
